import { render, staticRenderFns } from "./PackagesInUnit.vue?vue&type=template&id=9feafc48&scoped=true"
import script from "./PackagesInUnit.vue?vue&type=script&lang=js"
export * from "./PackagesInUnit.vue?vue&type=script&lang=js"
import style0 from "./PackagesInUnit.vue?vue&type=style&index=0&id=9feafc48&prod&scoped=true&lang=css"
import style1 from "./PackagesInUnit.vue?vue&type=style&index=1&id=9feafc48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9feafc48",
  null
  
)

export default component.exports